'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Skeleton } from '@common/components';
import { QuerySuspenseErrorBoundary } from '@/components/organism/QuerySuspenseErrorBoundary';
import { MERCHANT_TAB, type MerchantTab } from '../_constants';
import { MerchantBrandList } from './MerchantBrandList';
import { MerchantProductList } from './MerchantProductList';
const MerchantListFallback = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul aria-hidden={true} className="flex flex-col px-20 py-12">{[0, 1, 2].map(_temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
interface MerchantTabContentProps {
  activeTab: MerchantTab;
}
export const MerchantTabContent = t0 => {
  const $ = _c(3);
  const {
    activeTab
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MerchantListFallback />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== activeTab) {
    t2 = <QuerySuspenseErrorBoundary suspenseFallback={t1} errorFallback={_temp2}>{activeTab === MERCHANT_TAB.PRODUCT ? <MerchantProductList /> : <MerchantBrandList />}</QuerySuspenseErrorBoundary>;
    $[1] = activeTab;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(index) {
  return <li key={index} className="flex items-center gap-12 py-12"><Skeleton className="size-40 shrink-0 rounded-pill" /><div className="flex flex-1 flex-col gap-4"><Skeleton typo="body4" className="w-1/3" /><Skeleton typo="caption1" className="w-2/3" /></div></li>;
}
function _temp2(t0) {
  const {
    resetErrorBoundary
  } = t0;
  return <div className="flex min-h-240 flex-col items-center justify-center gap-12 px-20"><p className="font-500 text-Gray-600 typo-body4">제휴몰을 불러오지 못했어요</p><Button theme="sub-line" dimensions="H40" onClick={resetErrorBoundary}>다시 시도</Button></div>;
}